import Env from '../env'
import {API, ALIAS} from '../api'
import {compareVersion} from '../utils'

const noop = () => {}

// support方法检测某个接口在当前APP上是否支持，只适用于可以进行方法名快捷调用的接口
const support = (fnName) => {
    let cfg = API[fnName]
    let isSupport = false
    let support

    if (cfg) {
        support = cfg['support']
        if (typeof support === 'string' && compareVersion('>=' + support) === true) {
            isSupport = true
        } else if (typeof support === 'object' && support.length > 0) {
            for (let i = 0; i < support.length; i++) {
                let item = support[i]
                if (Env.isAndroidApp && item.type.toLowerCase() === 'android' && compareVersion('>=' + item.version) === true) {
                    isSupport = true
                } else if (Env.isIOSApp && item.type.toLowerCase() === 'ios' && compareVersion('>=' + item.version) === true) {
                    isSupport = true
                }
            }
        }
    }
    // TODO: 确定新加的bridge所支持的版本
    // isSupport = true
    return isSupport
}

// 固定参数格式(String ApiName, JSON params, function callback)调用
const handle = (() => {
    let flag = 0

    return (...args) => {
        try {
            if (Env.isIOSApp) {
                if (window.DidiJSBridge) {
                    // iOS首次执行bridge要init一次
                    if (!flag && window.DidiJSBridge.init) {
                        window.DidiJSBridge.init(() => {})
                        flag++
                    }
                    window.DidiJSBridge.callHandler.apply(null, args)
                } else {
                    document.addEventListener('DidiJSBridgeReady', () => {
                        if (!flag && window.DidiJSBridge.init) {
                            window.DidiJSBridge.init(() => {})
                            flag++
                        }
                        window.DidiJSBridge.callHandler.apply(null, args)
                    }, false)
                }
            } else if (Env.isAndroidApp) {
                if (window.DidiJSBridge) {
                    window.DidiJSBridge.callHandler.apply(null, args)
                } else {
                    document.addEventListener('DidiJSBridgeReady', () => {
                        window.DidiJSBridge.callHandler.apply(null, args)
                    }, false)
                }
            } else {
                // 比较老的iOS司机端可能会进入此逻辑
                // 但是2.4.4司机端已经强升，以下版本的司机端可以认为非正常情况
                console.error('Bridge error: Your web app is not running in a driver app!')
            }
        } catch (e) {
            console.error('Bridge error: ' + e)
        }
    }
})()

// 将调用方传来的多种形式的参数整合成native识别的固定参数格式(String fnName, JSON params, Function callback)再进行调用
const fn = function (ApiName, ApiConfig, args) {
    let name = ApiConfig['name'] || ApiName
    let prepare = ApiConfig['prepare']
    let params

    for (let i = 0; i < ALIAS.length; i++) {
        if (ApiName === ALIAS[i]) {
            console.warn('Bridge warn: Method ' + ApiName + ' marked as an alias of bridge method ,please use standard method in http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=116169534')
            break
        }
    }
    if (!support(ApiName)) {
        console.error(`Bridge error: Method ${ApiName} is not supported. This is mainly because: \n1. The method does not exit. Please check wiki at http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=117152777 \n2. The method does not support quick call. \n3. This page is not in a driver app or your app is too old.`)
        return
    }
    if (prepare && typeof prepare === 'function') {
        if (args.length === 0) {
            params = [{}, noop]
        } else if (args.length === 1) {
            params = typeof args[0] === 'function' ? [{}, args[0]] : [args[0], noop]
        } else if (args.length === 2 && typeof args[0] === 'object' && typeof args[1] === 'function') {
            params = args
        } else {
            console.error('Bridge error: Wrong parameters!')
            return
        }
        let newArgs = prepare.apply(null, params)
        newArgs && handle.apply(null, newArgs)
    } else if (name) {
        switch (args.length) {
            case 0:
                params = [name, {}, noop]
                break
            case 1:
                if (typeof args[0] === 'function') {
                    params = [name, {}, args[0]]
                } else if (typeof args[0] === 'object' || typeof args[0] === 'string') {
                    params = [name, args[0], noop]
                } else {
                    console.error('Bridge error: Wrong parameters!')
                }
                break
            default :
                if (typeof args[0] === 'object' && typeof args[1] === 'function') {
                    params = [name, args[0], args[1]]
                } else {
                    console.error('Bridge error: Wrong parameters!')
                }
        }
        if (params) {
            handle.apply(null, params)
        }
    }
}

export {
    support,
    handle,
    fn
}
